import Amplify from '@aws-amplify/core';
import Auth from '@aws-amplify/auth'; // eslint-disable-line no-unused-vars

import awsConfig from '@/config/awsAuth.json';

Amplify.configure(awsConfig);
